import Image from 'next/image';
import topupdated from '../../../../public/topupatednew.webp';
import clutch from '../../../../public/clutupdatednew.webp';
import dungs from '../../../../public/dungsnew.webp';
import esomar from '../../../../public/ESOMAR_member_RGB-17.webp';
import iso9001 from '../../../../public/iso-9001-updated.webp';
import iso27001 from '../../../../public/iso-27001-updated.webp';

export default function BuyNowCredibility({ regionalText }) {
  return (
    <div className="rounded-md text-center mt-4">
      <p className="mb-2 font-bold">{regionalText}</p>
      <div className="flex flex-row justify-around items-center bg-white shadow-md h-20 px-1 gap-1 lg:-mx-12">
        <div className="flex-1">
          <Image
            src={dungs}
            alt="Dungs"
            title="Dungs"
            width={90}
            height={'auto'}
          />
          <p className="text-black text-[10px]">860519526</p>
        </div>

        <div className="flex-1">
          <Image
            src={esomar}
            alt="Esomar"
            title="Esomar"
            width={90}
            height={'auto'}
          />
        </div>
        <div className="flex-1">
          <Image
            src={iso9001}
            alt="ISO-9001"
            title="ISO-9001"
            width={65}
            height={'auto'}
            className="mx-auto"
          />
          <p className="text-black text-[10px] text-center">9001:2015</p>
        </div>
        <div className="flex-1">
          <Image
            src={iso27001}
            alt="ISO-27001"
            title="ISO-27001"
            width={65}
            height={'auto'}
            className="mx-auto"
          />
          <p className="text-black text-[10px] text-center">27001:2022</p>
        </div>
        <div className="flex-1">
          <Image
            src={clutch}
            alt="Clutch"
            title="Clutch"
            width={90}
            height={'auto'}
          />
        </div>
        <div className="flex-1">
          <Image
            src={topupdated}
            alt="Top Marketing agency"
            title="Top Marketing agency"
            width={90}
            height={'auto'}
          />
        </div>
      </div>
    </div>
  );
}
